import type { Snippet } from '@/types'
import { SnippetCard } from './SnippetCard'

interface SnippetListProps {
  snippets: Snippet[]
  onUpdate: (id: string, content: string) => Promise<void>
  onDelete: (id: string) => Promise<void>
  emptyMessage?: string
}

export const SnippetList = ({
  snippets,
  onUpdate,
  onDelete,
  emptyMessage = 'No snippets yet',
}: SnippetListProps) => {
  if (snippets.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        <p>{emptyMessage}</p>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {snippets.map((snippet) => (
        <SnippetCard
          key={snippet.id}
          snippet={snippet}
          onUpdate={onUpdate}
          onDelete={onDelete}
        />
      ))}
    </div>
  )
}
